export const curryGetFunction = <A extends any[], T>(
  fn: (accountId: string, projectId: string, ...args: A) => T,
) => {
  return (accountId: string, projectId: string, ...args: A) => {
    return (): T => {
      return fn(accountId, projectId, ...args);
    };
  };
};

export const curryPostFunction =
  <K extends Record<string, any>, R>(fn: (args: K) => R) =>
  <P extends Partial<K>>(partial: P) =>
  (
    remaining: {
      [Key in Exclude<keyof K, keyof P>]: K[Key];
    },
  ) =>
    fn({ ...partial, ...remaining } as K);
